import { render, staticRenderFns } from "./error-notification.vue?vue&type=template&id=3cca7622&scoped=true&"
import script from "./error-notification.vue?vue&type=script&lang=js&"
export * from "./error-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca7622",
  null
  
)

export default component.exports